import React from 'react';
import { Tooltip } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { colors } from '@/globalStyles';

export const TooltipStyled = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: colors.white,
    color: colors.black,
    boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.25)',
    fontSize: 16,
    fontWeight: 'normal',
    padding: 0,
    borderRadius: 6,
    maxWidth: 'unset',
  },
  [`& .MuiTooltip-arrow`]: {
    color: colors.white,
    '&:before': {
      boxShadow: '0 0 3px 0 rgba(0, 0, 0, 0.25)',
    },
  },
}));

export const OptionPanelTooltipStyled = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: colors.white,
    color: colors.black,
    boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.25)',
    fontSize: 16,
    fontWeight: 'normal',
    padding: 0,
    borderRadius: 6,
    maxWidth: 'unset',
  },
  [`& .MuiTooltip-arrow`]: {
    left: 'unset !important',
    right: '23px !important',
    transform: 'unset !important',
    color: colors.white,
    '&:before': {
      boxShadow: '0 0 3px 0 rgba(0, 0, 0, 0.25)',
    },
  },
}));
